import { render, staticRenderFns } from "./aiCustomPage.vue?vue&type=template&id=6c1a47cb&scoped=true&"
import script from "./aiCustomPage.vue?vue&type=script&lang=js&"
export * from "./aiCustomPage.vue?vue&type=script&lang=js&"
import style0 from "./aiCustomPage.vue?vue&type=style&index=0&id=6c1a47cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1a47cb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c1a47cb')) {
      api.createRecord('6c1a47cb', component.options)
    } else {
      api.reload('6c1a47cb', component.options)
    }
    module.hot.accept("./aiCustomPage.vue?vue&type=template&id=6c1a47cb&scoped=true&", function () {
      api.rerender('6c1a47cb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/aiCustomPage.vue"
export default component.exports